/* For The Trees — free-shipping progress in the cart drawer and cart page */
(function () {
  var threshold = window.fttFreeShipCents || 2800;
  var busy = false;
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function paint(cart) {
    var totals = document.querySelectorAll('.cart__summary-totals');
    for (var i = 0; i < totals.length; i++) {
      var el = totals[i];
      var bar = el.parentNode.querySelector(':scope > .ftt-ship');
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'ftt-ship';
        bar.setAttribute('role', 'status');
        bar.innerHTML = '<span></span><div class="ftt-ship__bar"><i></i></div>';
        el.parentNode.insertBefore(bar, el);
      }
      var left = threshold - cart.total_price;
      var msg = cart.item_count === 0 ? 'Free shipping on orders over ' + money(threshold)
        : (left > 0 ? 'You are ' + money(left) + ' away from free shipping' : 'You have free shipping');
      bar.querySelector('span').textContent = msg;
      bar.querySelector('i').style.width = Math.min(100, Math.round(cart.total_price / threshold * 100)) + '%';
    }
  }
  function refresh() {
    if (busy) return;
    busy = true;
    setTimeout(function () {
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { busy = false; paint(c); })
        .catch(function () { busy = false; });
    }, 200);
  }
  function missing() {
    var totals = document.querySelectorAll('.cart__summary-totals');
    for (var i = 0; i < totals.length; i++) {
      if (!totals[i].parentNode.querySelector(':scope > .ftt-ship')) return true;
    }
    return false;
  }
  document.addEventListener('cart:update', refresh);
  document.addEventListener('DOMContentLoaded', refresh);
  new MutationObserver(function () { if (missing()) refresh(); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
